module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-wrapper"
  }, [_c('div', {
    staticClass: "breadcrumb-wrapper"
  }, [_c('span', [_vm._v("问卷调查 / " + _vm._s(_vm.id ? '编辑' : '新增'))]), _vm._v(" "), _c('div', {
    staticClass: "action-btns"
  }, [(_vm.formData.status === 2 || !_vm.id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clickSave
    }
  }, [_vm._v("保存")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("返回")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-wrapper"
  }, [_c('el-form', {
    ref: "formRef",
    staticClass: "advert-popup-form",
    attrs: {
      "label-width": "100px",
      "label-position": "left",
      "model": _vm.formData,
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "maxlength": "10",
      "show-word-limit": "",
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.title),
      callback: function($$v) {
        _vm.$set(_vm.formData, "title", $$v)
      },
      expression: "formData.title"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tip-text"
  }, [_vm._v("限制为10个字")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "H5链接",
      "prop": "h5Url"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.h5Url),
      callback: function($$v) {
        _vm.$set(_vm.formData, "h5Url", $$v)
      },
      expression: "formData.h5Url"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "popup-prompt-form-item",
    attrs: {
      "label": "是否弹窗提示",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "popup-prompt-row"
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.isPopup),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isPopup", $$v)
      },
      expression: "formData.isPopup"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1), _vm._v(" "), (_vm.formData.isPopup === 1) ? _c('el-input', {
    staticClass: "popup-prompt-input",
    attrs: {
      "maxlength": "20",
      "placeholder": "请填写弹窗内容，最多20个字",
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.popupContent),
      callback: function($$v) {
        _vm.$set(_vm.formData, "popupContent", $$v)
      },
      expression: "formData.popupContent"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "popup-prompt-example"
  }, [_c('span', {
    staticClass: "popup-prompt-example-label"
  }, [_vm._v("示例")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.popupPromptExampleImg,
      "alt": "弹窗示例"
    }
  })])], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "奖励",
      "prop": "rewardType"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择奖励类型",
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.rewardType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "rewardType", $$v)
      },
      expression: "formData.rewardType"
    }
  }, _vm._l((_vm.rewardTypeOptions), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宣传图片",
      "prop": "coverImage"
    }
  }, [(_vm.formData.status !== 1) ? _c('UploadImage', {
    attrs: {
      "actionUrl": "/adminapi/v1/basicTools/upload/one?uploadImageType=1",
      "tips": "支持jpg、png，不超过10MB内",
      "urls": _vm.formData.coverImage
    },
    on: {
      "onUrls": _vm.imageUploaded
    }
  }) : (_vm.formData.coverImage) ? _c('div', {
    staticClass: "image-preview"
  }, [_c('img', {
    attrs: {
      "src": _vm.formData.coverImage,
      "alt": "宣传图片"
    }
  })]) : _c('span', [_vm._v("-")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "日期选择",
      "prop": "dateRange"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "range-separator": "—",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "value-format": "yyyy-MM-dd",
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.formData, "dateRange", $$v)
      },
      expression: "formData.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "学校",
      "prop": "scopeType",
      "required": ""
    }
  }, [_c('div', {
    staticClass: "school-section"
  }, [_c('div', {
    staticClass: "school-scope-row"
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("涉及院系：")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "disabled": _vm.formData.status === 1
    },
    model: {
      value: (_vm.formData.scopeType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "scopeType", $$v)
      },
      expression: "formData.scopeType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("全部")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("部分")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "campus-zone-section"
  }, [_c('div', {
    staticClass: "section-label"
  }, [_vm._v(_vm._s(_vm.formData.scopeType === 1 ? '屏蔽校区' : '应用校区'))]), _vm._v(" "), (_vm.formData.status !== 1) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "margin-bottom": "8px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "flex": "1",
      "margin-right": "8px"
    },
    attrs: {
      "placeholder": "请选择校区",
      "filterable": ""
    },
    model: {
      value: (_vm.selectedCampusUnid),
      callback: function($$v) {
        _vm.selectedCampusUnid = $$v
      },
      expression: "selectedCampusUnid"
    }
  }, _vm._l((_vm.campusZoneList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.handleAddCampus
    }
  }, [_vm._v("添加")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "campus-list-wrap"
  }, _vm._l((_vm.formData.campusList), function(item) {
    return _c('div', {
      key: item.value,
      staticClass: "campus-item"
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), (_vm.formData.status !== 1) ? _c('el-button', {
      attrs: {
        "type": "text",
        "icon": "el-icon-circle-close"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteCampus(item.value)
        }
      }
    }) : _vm._e()], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "campus-footer"
  }, [_vm._v("\n                     共计" + _vm._s(_vm.formData.campusList.length) + "所学校\n                  ")])])])]), _vm._v(" "), (_vm.id) ? _c('el-form-item', {
    attrs: {
      "label": "创建时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formatDateTime(_vm.formData.createTime) || '-'))])]) : _vm._e(), _vm._v(" "), (_vm.id) ? _c('el-form-item', {
    attrs: {
      "label": "更新时间"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.formatDateTime(_vm.formData.updateTime) || '-'))])]) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63b832f0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/activity/questionnaireSurvey.vue
// module id = 1050
// module chunks = 0